/* global __DEV__ */

export const currentEnvironment = () =>
  process.env.APP_ENV ||
  process.env.REACT_APP_ENV ||
  process.env.NEXT_PUBLIC_ENV ||
  process.env.NODE_ENV ||
  'production';

// The env name says which backend we point at, not where the code runs, so read the runtime instead.
export const isLocalRuntime = () => {
  if (typeof __DEV__ !== 'undefined') {
    return __DEV__;
  }

  return process.env.NODE_ENV === 'development';
};
